import { render } from "./BaseCheckbox.vue?vue&type=template&id=33bdc198&scoped=true"
import script from "./BaseCheckbox.vue?vue&type=script&lang=js"
export * from "./BaseCheckbox.vue?vue&type=script&lang=js"

import "./BaseCheckbox.vue?vue&type=style&index=0&id=33bdc198&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33bdc198"]])

export default __exports__